import React from 'react';
import dubaiPoliceLogo from '../../assets/dubai-police-logo.png';

const WelcomeScreen = ({ onStartClick }) => {
  return (
    <div className="h-screen relative overflow-hidden bg-gradient-to-b from-white via-[#F6FBF9] to-[#E4EFEA]">
      {/* Vertical spine - left authority bar */}
      <div className="forensic-spine" />

      {/* Background layers */}
      <div className="forensic-grid-overlay" />
      <div className="forensic-map-overlay" />
      <div className="forensic-digital-noise" />
      <div className="forensic-fingerprint-texture" />
      <div className="forensic-circuit-lines" />

      {/* Geometric green blocks */}
      <div className="forensic-block forensic-block-1" />
      <div className="forensic-block forensic-block-2" />
      <div className="forensic-block forensic-block-3" />
      <div className="forensic-corner-tl" />
      <div className="forensic-corner-br" />

      {/* Main content */}
      <div className="relative z-10 h-full flex flex-col">
        {/* Header with logo */}
        <header className="flex justify-end items-start px-8 pt-6 pb-4">
          <img
            src={dubaiPoliceLogo}
            alt="Dubai Police"
            className="h-16 w-auto"
          />
        </header>

        {/* Header line */}
        <div className="h-[2px] mx-8 bg-gradient-to-r from-[#0e734b] via-[#0e734b] to-transparent" style={{ backgroundSize: '60% 100%', backgroundRepeat: 'no-repeat' }} />

        {/* Main content area */}
        <main className="flex-1 flex flex-col items-center justify-center px-8 text-center">
          {/* Event Title - Bilingual */}
          <div className="space-y-2 mb-6">
            <h1 className="text-[3.5rem] font-black text-[#0e734b] leading-tight font-arabic" dir="rtl">
              هل انته جاهز لتكون الخبير الجنائي؟
            </h1>
            <h2 className="text-[2.5rem] font-title uppercase text-[#1A1A1A] leading-tight">
              Ready for your forensic identity?
            </h2>
          </div>

          {/* Arabic tagline */}
          <p className="text-xl font-bold mb-8 font-arabic" dir="rtl">
            <span className="text-[#4A5550]">إبتكر.</span>
            {' '}
            <span className="text-[#0e734b]">تَواصَل.</span>
            {' '}
            <span className="text-[#4A5550]">حَلّ.</span>
          </p>

          {/* Call to action text */}
          {/* <div className="space-y-1 mb-6">
            <p className="text-lg font-bold text-[#4A5550] font-arabic" dir="rtl">
              هل انته جاهز لتكون الخبير الجنائي؟
            </p>
            <p className="text-base font-semibold text-[#6B7770]">
              Ready for your forensic identity?
            </p>
          </div> */}

          {/* CTA Button - Bilingual */}
          <button
            onClick={onStartClick}
            className="forensic-btn-primary text-xl px-16 py-5 mb-8 flex items-center gap-3"
          >
            <span className="font-title uppercase">Begin</span>
            <span className="text-white/60">|</span>
            <span className="font-arabic font-bold">ابدأ</span>
          </button>

        </main>

        {/* Footer */}
        <footer className="px-8 pb-6 pt-4">
        </footer>
      </div>
    </div>
  );
};

export default WelcomeScreen;
